import { TransactionPaymentMethodEnum } from "@repo/core/constants/transactions";
import { TransactionOperationEnum } from "@repo/core/enums/receipts";

export const getPaymentMethodNameByType = (
  paymentMethod: TransactionPaymentMethodEnum
) => {
  switch (paymentMethod) {
    case TransactionPaymentMethodEnum.CREDIT:
      return "Crédito";
    default:
      return "Crédito";
  }
};

export const getOperationStringByType = (
  operation: TransactionOperationEnum
) => {
  switch (operation) {
    case TransactionOperationEnum.WITHDRAW:
      return "Saque Emergencial";
    case TransactionOperationEnum.PURCHASE:
      return "Compra";
    case TransactionOperationEnum.POINTS:
      return "Pontuação";
    case TransactionOperationEnum.BONUS_RETRIEVAL:
      return "Resgate";
    default:
      return "Compra";
  }
};
